define('router/router-tasks/initial-page-task',['require','lodash','lib/auth/auth','api-access','web-urls','lib/check-first-visit','api-access','cookie-handler','router/router-tasks/marketing-channel-task'],function (require) {
    var _ = require('lodash');
    var auth = require('lib/auth/auth');
    var userApi = require('api-access').user;
    var webUrls = require('web-urls');
    var checkFirstVisit = require('lib/check-first-visit');
    var apiAccess = require('api-access');
    var cookieHandler = require('cookie-handler');
    var marketingChannelTasks = require('router/router-tasks/marketing-channel-task');

    var checkG2MM = function () {
        var check = $.Deferred();

        apiAccess.gotomeet.getByUserKey()
          .then(function () {
              check.resolve(true);
          })
          .fail(function () {
              check.resolve(false);
          });
        return check;
    };

    /**
     * Decides if the page should be automatically routed to some other page initially.
     * Should only be executed the first navigation a user makes, not for subsequent navigations.
     *
     * @return {Promise} Resolves with a route fragment usable by the guardRoute method in Router.
     */
    return function () {
        if (auth.getToken()) {
            var loadTierSettings = $.when(
                userApi.tierSettings('g2m'),
                userApi.tierSettings('g2mfree'),
                userApi.settings(),
                checkG2MM()
            );

            var promise = $.Deferred();

            loadTierSettings.then(function (g2mResponse, g2mFreeResponse, userSettingsResponse, hasG2MM) {
                var g2m = g2mResponse[0];
                var g2mFree = g2mFreeResponse[0];
                var userSettings = userSettingsResponse[0];

                var onboardingEnabled = webUrls.get('onboardingEnabled') === 'true';
                var onboardingCompleted = userSettings.onboardingCompleted;

                // check onboarding flag on any tier, so we don't send upgraded or downgraded
                //  users to the onboarding flow again
                var onboardingViewed = _.any(_.pluck([g2m, g2mFree], 'onboardingViewed'));

                if (!onboardingViewed) {
                    /*
                     * onboardingViewed is false for new users who have never been to setup flow
                     * this check sets the onboardingCompleted flag to false
                     * onboardingCompleted flag is used to send the user back to setup flow
                     * if the user has not reserved G2MM
                     */
                    onboardingCompleted = false;
                    userApi.updateSettings({onboardingCompleted: false});
                }

                if (hasG2MM && !onboardingCompleted) {
                    /*
                    * For the existing users who changes plan, all flags get reset
                    * and if they have G2MM, the users get stuck in the onboarding loop
                    * This check prevents users from entering the onboarding loop again
                    * that have G2MM set and change their plan
                    */
                    onboardingCompleted = true;
                    userApi.updateSettings({onboardingCompleted: true});
                }

                checkFirstVisit.set(!onboardingCompleted);

                var marketingChannelCookieValue = cookieHandler.get('marketingChannel');

                /*
                * SetSale tab is to be shown to the user if
                * 1. It is not first login
                * 2. setSale is provisioned but not enabled
                * 3. The tab is not shown previously
                */
                var showSetSaleTab = !userSettings.setSaleAnalyticsTabShown
                    && userSettings.setSaleProvisioned
                    && userSettings.setSaleEntitled
                    && !userSettings.setSaleEnabled
                    && onboardingCompleted;

                if (marketingChannelCookieValue) {
                    promise.resolve(marketingChannelTasks(marketingChannelCookieValue));
                } else if ((!onboardingViewed || !onboardingCompleted) && onboardingEnabled) {
                    userApi.getServiceStatus().then(function (status) {
                        if (!status['gotomeetme-service'].up) {
                            promise.resolve('setup-error');
                        } else {
                            promise.resolve('setup');
                        }
                    });
                } else if (showSetSaleTab) {
                    promise.resolve(webUrls.get('setsaleUrl'));
                } else {
                    promise.resolve('');
                }
            })
            .fail(function () {
                // if something fails, just send the user to the root page
                promise.resolve('');
            });

            return promise.promise();
        }

        // Proceed without redirection if the user is not authenticated
        return $.Deferred().resolve(true).promise();
    };
});

